import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useParams, useNavigate } from "react-router-dom";
import { Image, ArrowLeft, FileText, X } from "react-feather";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import testImg from "../../assets/images/samples/test.jpg";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

function WorkOrderDone() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [previewImg, setPreviewImg] = useState(null);
  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(""); // "ambil" | "reject"
  const [showRatingModal, setShowRatingModal] = useState(false);
  const [showReasonModal, setShowReasonModal] = useState(false);
  const [rating, setRating] = useState("");
  const [reason, setReason] = useState("");

  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  const dateStr = `${yyyy}${mm}${dd}`;
  // Dummy: ambil data order by id
  const dummyOrders = [
    {
      id: 1,
      external_ref: `TGR-${dateStr}-001`,
      customer_name: "Budi",
      customer_phone: "08123456789",
      customer_address: "Jl. Melati No. 12",
      is_customer: true,
      channel: "Call Center",
      complaint_type: "Air Mati",
      job_type: "Perbaikan",
      category: "Teknis",
      description: "Air tidak keluar sejak pagi",
      region_id: "Region-01",
      province: "Jawa Barat",
      kabupaten: "Bandung",
      kecamatan: "Cimahi",
      kelurahan: "Leuwigajah",
      photo_url: testImg,
      created_by: "Admin",
      tanggal: "2025-09-24 16:55:40",
      priority: "critical",
      petugas: "Kiluwa",
      kasie: "Hisoka",
      status: "new",
    },
    {
      id: 2,
      external_ref: `TGR-${dateStr}-002`,
      customer_name: "Siti",
      customer_phone: "08987654321",
      customer_address: "Jl. Mawar No. 45",
      is_customer: false,
      channel: "Mobile App",
      complaint_type: "Meter Rusak",
      job_type: "Penggantian",
      category: "Meteran",
      description: "Meter tidak bisa terbaca",
      region_id: "Region-02",
      province: "Jawa Tengah",
      kabupaten: "Semarang",
      kecamatan: "Tembalang",
      kelurahan: "Meteseh",
      photo_url: testImg,
      created_by: "Operator",
      tanggal: "2025-09-23 11:55:40",
      priority: "critical",
      petugas: "Kiluwa",
      kasie: "Hisoka",
      status: "in_progress",
    },
    {
      id: 3,
      external_ref: `TGR-${dateStr}-003`,
      customer_name: "Andi",
      customer_phone: "08122334455",
      customer_address: "Jl. Kenanga No. 8",
      is_customer: true,
      channel: "Website",
      complaint_type: "Air Keruh",
      job_type: "Inspeksi",
      category: "Kualitas",
      description: "Air berwarna coklat sejak kemarin",
      region_id: "Region-03",
      province: "DKI Jakarta",
      kabupaten: "Jakarta Selatan",
      kecamatan: "Tebet",
      kelurahan: "Manggarai",
      photo_url: testImg,
      created_by: "Customer Service",
      tanggal: "2025-09-22 10:20:40",
      priority: "critical",
      petugas: "Kiluwa",
      kasie: "Hisoka",
      status: "new",
    },
    {
      id: 4,
      external_ref: `TGR-${dateStr}-004`,
      customer_name: "Rina",
      customer_phone: "08211222333",
      customer_address: "Jl. Flamboyan No. 10",
      is_customer: true,
      channel: "Walk In",
      complaint_type: "Kebocoran Pipa",
      job_type: "Perbaikan",
      category: "Teknis",
      description: "Ada kebocoran pipa depan rumah",
      region_id: "Region-04",
      province: "Banten",
      kabupaten: "Tangerang",
      kecamatan: "Karawaci",
      kelurahan: "Cimone",
      photo_url: testImg,
      created_by: "Admin",
      tanggal: "2025-09-21 08:10:40",
      priority: "critical",
      petugas: "Kiluwa",
      kasie: "Hisoka",
      status: "in_progress",
    },
    {
      id: 5,
      external_ref: `TGR-${dateStr}-005`,
      customer_name: "Agus",
      customer_phone: "081355667788",
      customer_address: "Jl. Sakura No. 2",
      is_customer: false,
      channel: "Mobile App",
      complaint_type: "Tagihan Tidak Sesuai",
      job_type: "Verifikasi",
      category: "Administrasi",
      description: "Tagihan bulan ini melonjak",
      region_id: "Region-05",
      province: "Jawa Timur",
      kabupaten: "Surabaya",
      kecamatan: "Wonokromo",
      kelurahan: "Darmo",
      photo_url: testImg,
      created_by: "Billing",
      tanggal: "2025-09-20 15:45:10",
      priority: "medium",
      petugas: "Kiluwa",
      kasie: "Hisoka",
      status: "completed",
    },
    {
      id: 6,
      external_ref: `TGR-${dateStr}-006`,
      customer_name: "Dewi",
      customer_phone: "087755443322",
      customer_address: "Jl. Cempaka No. 6",
      is_customer: true,
      channel: "Call Center",
      complaint_type: "Air Kecil",
      job_type: "Inspeksi",
      category: "Teknis",
      description: "Air mengalir sangat kecil",
      region_id: "Region-01",
      province: "Jawa Barat",
      kabupaten: "Bekasi",
      kecamatan: "Bekasi Timur",
      kelurahan: "Margahayu",
      photo_url: testImg,
      created_by: "Admin",
      tanggal: "2025-09-19 11:50:20",
      priority: "medium",
      petugas: "Kiluwa",
      kasie: "Hisoka",
      status: "new",
    },
    {
      id: 7,
      external_ref: `TGR-${dateStr}-007`,
      customer_name: "Fajar",
      customer_phone: "085600112233",
      customer_address: "Jl. Anggrek No. 77",
      is_customer: false,
      channel: "Website",
      complaint_type: "Air Berbau",
      job_type: "Pengujian",
      category: "Kualitas",
      description: "Air berbau tidak sedap",
      region_id: "Region-06",
      province: "Jawa Tengah",
      kabupaten: "Solo",
      kecamatan: "Laweyan",
      kelurahan: "Sondakan",
      photo_url: testImg,
      created_by: "QA",
      tanggal: "2025-09-18 13:00:10",
      priority: "high",
      petugas: "Kiluwa",
      kasie: "Hisoka",
      status: "in_progress",
    },
    {
      id: 8,
      external_ref: `TGR-${dateStr}-008`,
      customer_name: "Maya",
      customer_phone: "081234998877",
      customer_address: "Jl. Dahlia No. 15",
      is_customer: true,
      channel: "Mobile App",
      complaint_type: "Meter Macet",
      job_type: "Penggantian",
      category: "Meteran",
      description: "Meter air tidak bergerak",
      region_id: "Region-07",
      province: "Bali",
      kabupaten: "Denpasar",
      kecamatan: "Denpasar Barat",
      kelurahan: "Pemecutan",
      photo_url: testImg,
      created_by: "Operator",
      tanggal: "2025-09-17 09:35:20",
      priority: "low",
      petugas: "Kiluwa",
      kasie: "Hisoka",
      status: "completed",
    },
    {
      id: 9,
      external_ref: `TGR-${dateStr}-009`,
      customer_name: "Hasan",
      customer_phone: "083344556677",
      customer_address: "Jl. Kamboja No. 33",
      is_customer: true,
      channel: "Call Center",
      complaint_type: "Pipa Tersumbat",
      job_type: "Perbaikan",
      category: "Teknis",
      description: "Air tidak keluar karena pipa mampet",
      region_id: "Region-08",
      province: "Sumatera Utara",
      kabupaten: "Medan",
      kecamatan: "Medan Kota",
      kelurahan: "Kesawan",
      photo_url: testImg,
      created_by: "Admin",
      tanggal: "2025-09-16 15:03:00",
      priority: "low",
      petugas: "Kiluwa",
      kasie: "Hisoka",
      status: "new",
    },
    {
      id: 10,
      external_ref: `TGR-${dateStr}-010`,
      customer_name: "Nina",
      customer_phone: "082199887766",
      customer_address: "Jl. Teratai No. 5",
      is_customer: false,
      channel: "Walk In",
      complaint_type: "Sambungan Baru",
      job_type: "Pemasangan",
      category: "Layanan",
      description: "Permintaan pemasangan baru",
      region_id: "Region-09",
      province: "Lampung",
      kabupaten: "Bandar Lampung",
      kecamatan: "Tanjung Karang",
      kelurahan: "Durian Payung",
      photo_url: testImg,
      created_by: "Customer Service",
      tanggal: "2025-09-15 10:20:40",
      priority: "low",
      petugas: "Kiluwa",
      kasie: "Hisoka",
      status: "canceled",
    },
  ];

  // === HANDLE PREVIEW ===
  const handlePreview = (img) => {
    setPreviewImg(img);
    setShow(true); // buka modal
  };

  const handleClose = () => {
    setShow(false); // tutup modal
    setPreviewImg(null);
  };

  const handleOpenModal = (type) => {
    setModalType(type);
    setShowModal(true);
  };

  const handleConfirm = () => {
    if (modalType === "approve") {
      // Tutup modal konfirmasi approve
      setShowModal(false);
      // Buka modal penilaian
      setShowRatingModal(true);
    } else {
      // Tutup modal konfirmasi
      setShowModal(false);
      // Buka modal alasan reject
      setShowReasonModal(true);
    }
  };

  const handleSubmitRating = () => {
    if (!rating || rating < 1 || rating > 10) {
      toast.error("Harap berikan nilai antara 1 - 10 sebelum melanjutkan.");
      return;
    }

    // Simpan rating di sini (misalnya API call)
    console.log("Rating pekerjaan:", rating);

    // Tutup modal penilaian
    setShowRatingModal(false);
    toast.success(`Tiket berhasil di-approve dengan nilai ${rating}`);
    setRating("");
  };

  const handleSubmitReason = () => {
    if (!reason.trim()) {
      toast.error("Harap berikan alasan penolakan sebelum melanjutkan.");
      return;
    }

    console.log("Alasan reject:", reason);

    setShowReasonModal(false);
    toast.success("Tiket berhasil ditolak dengan alasan: " + reason);
    setReason("");
  };

  const order = dummyOrders.find((o) => String(o.id) === id);

  if (!order) {
    return (
      <div className="container mt-4">
        <h4>Data tidak ditemukan</h4>
        <button className="btn btn-secondary mt-3" onClick={() => navigate(-1)}>
          Kembali
        </button>
      </div>
    );
  }

  return (
    <>
      <div className="container mt-4">
        <div className="card shadow-sm">
          {/* Header utama */}
          <div className="card-header" style={{ backgroundColor: "#1a237e" }}>
            <h5 className="mb-0 text-white">
              Detail Tiket {order.external_ref}
            </h5>
          </div>

          <div className="card-body">
            {/* Header Info Tiket */}
            {/* <div className="mt-3">
              <div
                className="py-3 px-3 text-white"
                style={{
                  backgroundColor: "#3949ab",
                  borderTopLeftRadius: "0.5rem",
                  borderTopRightRadius: "0.5rem",
                }}
              >
                <h6 className="mb-0 text-white">Info Tiket</h6>
              </div>
            </div> */}

            <div
              className="d-flex justify-content-end px-3 py-2"
              style={{ backgroundColor: "#f5f6fa" }}
            ></div>

            {/* Tabel detail */}
            <div className="table-responsive">
              <table className="table table-bordered align-middle">
                <tbody>
                  <tr>
                    <th style={{ width: "20%" }}>Nama Pelanggan</th>
                    <td style={{ width: "30%" }}>{order.customer_name}</td>
                    <th style={{ width: "20%" }}>Telepon</th>
                    <td style={{ width: "30%" }}>{order.customer_phone}</td>
                  </tr>
                  <tr>
                    <th>Alamat</th>
                    <td>{order.customer_address}</td>
                    <th>Status Pelanggan</th>
                    <td>{order.is_customer ? "Pelanggan" : "Non Pelanggan"}</td>
                  </tr>
                  <tr>
                    <th>Media</th>
                    <td>{order.channel}</td>
                    <th>Category</th>
                    <td>{order.category}</td>
                  </tr>
                  <tr>
                    <th>Wilayah</th>
                    <td>{order.region_id}</td>
                    <th>Provinsi</th>
                    <td>{order.province}</td>
                  </tr>
                  <tr>
                    <th>Kabupaten</th>
                    <td>{order.kabupaten}</td>
                    <th>Kecamatan</th>
                    <td>{order.kecamatan}</td>
                  </tr>
                  <tr>
                    <th>Kelurahan</th>
                    <td>{order.kelurahan}</td>
                    <th>Priority</th>
                    <td>
                      <span
                        className={`badge ${
                          order.priority === "critical"
                            ? "bg-danger"
                            : order.priority === "medium"
                            ? "bg-warning text-dark"
                            : "bg-success"
                        }`}
                      >
                        {order.priority}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <th>Keluhan</th>
                    <td>{order.description}</td>
                    <th>Bukti Foto</th>
                    <td>
                      {order.photo_url ? (
                        <button
                          className="btn btn-sm btn-primary d-flex align-items-center"
                          onClick={() => handlePreview(order.photo_url)}
                        >
                          <Image size={16} className="me-1" />
                          Lihat Gambar
                        </button>
                      ) : (
                        <span className="text-muted">Tidak ada bukti foto</span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>Petugas</th>
                    <td>{order.petugas}</td>
                    <th>Kasie</th>
                    <td>{order.kasie}</td>
                  </tr>
                  <tr>
                    <th>Foto Sebelum Perbaikan</th>
                    <td>
                      {order.photo_url ? (
                        <button
                          className="btn btn-sm btn-primary d-flex align-items-center"
                          onClick={() => handlePreview(order.photo_url)}
                        >
                          <Image size={16} className="me-1" />
                          Gambar Sebelum Perbaikan
                        </button>
                      ) : (
                        <span className="text-muted">Tidak ada bukti foto</span>
                      )}
                    </td>

                    <th>Foto Sesudah Perbaikan</th>
                    <td>
                      {order.photo_url ? (
                        <button
                          className="btn btn-sm btn-primary d-flex align-items-center"
                          onClick={() => handlePreview(order.photo_url)}
                        >
                          <Image size={16} className="me-1" />
                          Gambar Sesudah Perbaikan
                        </button>
                      ) : (
                        <span className="text-muted">Tidak ada bukti foto</span>
                      )}
                    </td>
                  </tr>
                  {[2, 3].includes(
                    JSON.parse(localStorage.getItem("user"))?.role_id
                  ) && (
                    <tr>
                      <th>Aksi</th>
                      <td colSpan={3} className="d-flex gap-2">
                        <button
                          className="btn btn-sm text-white d-flex align-items-center"
                          style={{ backgroundColor: "rgb(29, 145, 37)" }}
                          onClick={() => handleOpenModal("approve")}
                        >
                          <FileText size={16} className="me-1" />
                          Approve
                        </button>

                        <button
                          className="btn btn-sm text-white d-flex align-items-center"
                          style={{ backgroundColor: "rgb(200, 50, 50)" }}
                          onClick={() => handleOpenModal("reject")}
                        >
                          <X size={16} className="me-1" />
                          Reject
                        </button>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Action buttons */}
            {/* Footer Aksi */}
            <div className="d-flex justify-content-between mt-3">
              {/* Kiri */}
              <div>
                <button
                  className="btn btn-secondary d-flex align-items-center"
                  onClick={() =>
                    navigate("/Wo/WorkOrder", {
                      state: { defaultTab: "done" },
                    })
                  }
                >
                  <ArrowLeft size={16} className="me-1" />
                  Kembali
                </button>
              </div>

              {/* Kanan */}
              <div>
                {/* <button className="btn btn-success d-flex align-items-center">
                  <Download size={16} className="me-1" />
                  Ambil Tiket
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Preview */}
      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Preview Foto</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {previewImg ? (
            <img
              src={previewImg}
              alt="Preview"
              className="img-fluid rounded shadow"
            />
          ) : (
            <p className="text-muted">Tidak ada gambar</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Tutup
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {modalType === "approve"
              ? "Konfirmasi Approve Tiket"
              : "Konfirmasi Reject Tiket"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalType === "approve"
            ? "Apakah Anda yakin ingin approve tiket ini?"
            : "Apakah Anda yakin ingin menolak (reject) tiket ini?"}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Batal
          </Button>
          <Button
            variant={modalType === "approve" ? "success" : "danger"}
            onClick={handleConfirm}
          >
            {modalType === "approve" ? "Approve Tiket" : "Reject Tiket"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Penilaian */}
      <Modal show={showRatingModal} onHide={() => {}} centered>
        <Modal.Header>
          <Modal.Title>Penilaian Pekerjaan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Berikan nilai (1 - 10)</Form.Label>
            <Form.Control
              type="number"
              min="1"
              max="10"
              value={rating}
              onChange={(e) => setRating(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={handleSubmitRating}>
            Simpan Nilai
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showReasonModal} onHide={() => {}} centered>
        <Modal.Header>
          <Modal.Title>Alasan Reject Tiket</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Tulis alasan penolakan</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Masukkan alasan..."
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary">Batal</Button>
          <Button variant="danger" onClick={handleSubmitReason}>
            Simpan Alasan
          </Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default WorkOrderDone;
